import { CONFIG } from '@frontend/config';
import { useGetAgencyById } from '@frontend/features/agencies/queries';

import { agencyCountryCode } from './agencyCountry';

/**
 * El país con el que arrancan los campos de país del formulario de reserva.
 *
 * La agencia es `CONFIG.AGENCY_ID`, que es la agencia OPERACIONAL de los
 * buscadores: en `travel-services` no hay selector de agencia en runtime, y es
 * el mismo criterio que ya usa `usePlacesEnabled` (documentado en
 * docs/RUTERO.md). No es el caso de una pantalla de configuración de agencia,
 * que sí toma el id de la ruta (21.2).
 *
 * La resolución del nombre a ISO-2 vive aparte, en `agencyCountry.ts`, para
 * que se pueda probar sin el entorno de Vite.
 */
export function useAgencyCountryCode(): string | undefined {
  const { data: agency } = useGetAgencyById({ id: String(CONFIG.AGENCY_ID) });
  return agencyCountryCode(agency?.country);
}
